import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import SearchProgress from '@Services/SearchProgress';
import QuickResultsService from '@Services/QuickResults';
import store from '@Store';
import isEmpty from 'lodash/isEmpty';
import { RESET_STATE, UPDATE_STATE_PARAMS, typeOfSearchProgressModal } from './SearchProgressModalConstants';

let unsubscribeInfo = null;
let unsubscribeWSErrors = null;
let progressStatus = {};

export const updateStateParams = (params) => ({
  type: UPDATE_STATE_PARAMS,
  params,
});

export const openSearchProgressModal = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfSearchProgressModal,
      dialogType: typeOfSearchProgressModal,
      movable: false,
      backdrop: true,
      ...props,
    })
  );
  dispatch(
    updateStateParams({
      searchId: props.searchId,
      priorityWatcher: props.priorityWatcher,
      queries: props.queries,
      requestId: props.requestId,
      queryFactItem: props.queryFactItem,
    })
  );
};

export const closeSearchProgressModal = () => (dispatch) => {
  dispatch(
    closeDialog({
      id: typeOfSearchProgressModal,
    })
  );
};

export const dispatchOpenSearchProgressModal = (...args) => {
  store.dispatch(openSearchProgressModal(...args));
};

export const dispatchCloseSearchProgressModal = () => {
  store.dispatch(closeSearchProgressModal());
};

export const dispatchUpdateStateParams = (...args) => {
  store.dispatch(updateStateParams(...args));
};

export const cancelSearch = (searchId, requestId) => {
  if (searchId) {
    SearchProgress.cancelSearch(searchId, requestId);
  }
};

export const getCurrentDbName = (priorityWatcher) => {
  if (!priorityWatcher) {
    return null;
  }
  return SearchProgress && SearchProgress.getCurrentDbName(priorityWatcher);
};

export const resetState = () => ({
  type: RESET_STATE,
});

export const destroy = () => (dispatch) => {
  dispatch(resetState());
  if (unsubscribeInfo) unsubscribeInfo();
  if (unsubscribeWSErrors) unsubscribeWSErrors();
  unsubscribeInfo = null;
  unsubscribeWSErrors = null;
  progressStatus = {};
};

export const buildQueriesProgress = (queries = {}) => {
  Object.keys(queries).forEach((databaseId) => {
    const queryId = queries[databaseId];

    progressStatus[queryId] = {
      finished: false,
    };
  });
};

function updateReceived(info, queries) {
  const progressInfo = info && info.payload;
  const queryId = info && info.info.query;

  if (!progressInfo) {
    return;
  }

  if (!progressStatus || isEmpty(progressStatus)) {
    buildQueriesProgress(queries);
  }

  if (progressInfo.finished && progressStatus[queryId]) {
    progressStatus[queryId].finished = true;
    SearchProgress.checkIfAllSearchesFinished(progressStatus);
  }
}

export const init = (queries) => () => {
  unsubscribeInfo = QuickResultsService.setupProcessInfoChannel((info) => {
    updateReceived(info, queries);
  });
  unsubscribeWSErrors = QuickResultsService.subscribeWSErrors(dispatchCloseSearchProgressModal);
};
